{
  "items": [
    {
      "fileName": "GENERIC-Family-01.mp4",
      "description": "The video shows three people, one man, one woman, and one baby, gathered indoors around a laptop computer. The woman is an adult female with a dark brown skin tone and long, dark black wavy hair, wearing a top, a blue denim button up shirt or blouse, smiling broadly with her mouth open, showing white teeth, giving a joyful, warm, happy visible expression, while holding the baby in her arms. The man is an adult male with a dark brown skin tone, a bald or shaved head, and a full dark beard, wearing a top, a mustard, orange yellow colored t-shirt, smiling and talking with his mouth open, pointing one finger toward the laptop screen, giving an animated, joyful, engaged visible expression. The baby is an infant with a light brown skin tone and light, thin hair, wearing a white, cream colored outfit or onesie patterned with small leaves and floral designs, with one fist near its mouth. The setting is an indoor modern living room and open kitchen environment, blurred softly out of focus behind the group, showing a wood paneled accent wall on the left side of the frame, a tall window with an orange, red colored awning visible outside, green potted plants, a light gray sofa, and a wooden side table. The lighting is bright, soft, and natural, consistent with daylight coming through the window, evenly illuminating the family without harsh shadows. The color palette is warm and vibrant, dominated by blue denim, mustard yellow, white, and wood brown tones, with green accents from the plants. The composition is a medium close up, closeup, upper body framing, with all three people positioned close together toward the center of the frame, facing toward a laptop computer, a white, silver colored laptop, visible in the foreground. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a shallow depth of field, keeping the living room background softly blurred while the family remains in sharp focus.",
      "keyElements": [
        "wood paneled wall",
        "window",
        "awning",
        "potted plants",
        "sofa",
        "side table",
        "laptop",
        "onesie pattern",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "happy",
        "animated",
        "engaged",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "blurred background",
        "bright lighting",
        "natural light",
        "warm tone",
        "vibrant",
        "family",
        "lifestyle",
        "man",
        "woman",
        "baby",
        "infant",
        "father",
        "mother",
        "beard",
        "bald",
        "yellow",
        "mustard",
        "denim",
        "blue",
        "onesie",
        "laptop",
        "plants",
        "window",
        "sofa",
        "video call"
      ]
    },
    {
      "fileName": "GENERIC-Family-02.mp4",
      "description": "The video shows three people, one man and two children, playing indoors in a living room. The man is an adult male with a dark brown skin tone, short dark curly hair, and a light beard, wearing a top, a plaid, checkered patterned button up shirt in black, white, and gray tones, along with blue denim jeans, kneeling on a sofa with a wide, open mouthed smile showing white teeth, giving an energetic, joyful, playful visible expression. The two children, one girl and one boy, both have curly dark brown hair and light brown skin tones, and are positioned on the man's back and shoulders with their arms stretched outward like airplane wings, both smiling and laughing, giving joyful, excited, playful visible expressions. The girl is wearing a white t-shirt, and the boy is wearing a plaid, checkered patterned button up shirt similar to the man's shirt. The setting is an indoor living room environment, blurred softly out of focus behind the group, showing a white sectional sofa, tall black framed windows or French doors with sheer white curtains, a green potted plant on the left side of the frame, and an open plan kitchen in the background with a white brick tile wall, wood shelving, hanging pendant lights, and a round wall clock. The lighting is bright and natural, consistent with daylight coming through the tall windows, evenly illuminating the family. The color palette is bright and neutral, dominated by white, gray, black, and denim blue tones, with green accents from the plant. The composition is a medium wide shot, full body framing, with the group positioned slightly off center in the frame, in motion. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a bright, airy look and a moderate depth of field.",
      "keyElements": [
        "sofa",
        "windows",
        "french doors",
        "curtains",
        "potted plant",
        "kitchen",
        "tile wall",
        "shelving",
        "pendant lights",
        "wall clock",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "energetic",
        "joyful",
        "playful",
        "excited",
        "candid",
        "action",
        "wide shot",
        "full body",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "neutral tone",
        "airy",
        "family",
        "lifestyle",
        "man",
        "children",
        "girl",
        "boy",
        "father",
        "curly hair",
        "beard",
        "plaid",
        "checkered",
        "shirt",
        "sofa",
        "windows",
        "curtains",
        "plant",
        "kitchen",
        "pendant light",
        "clock"
      ]
    },
    {
      "fileName": "GENERIC-Family-03.mp4",
      "description": "The video shows one man, an elderly adult male with a fair skin tone and short, white, gray hair. The man is wearing eyeglasses, dark rimmed eyeglasses, and has a light gray goatee or stubble, wearing a top, a light blue and white floral patterned button up shirt, waving one hand toward a laptop computer with a warm, friendly, welcoming visible expression, and a soft smile showing a hint of teeth. The setting is an indoor kitchen environment, showing a silver refrigerator, a gray cabinet or shelf displaying framed pictures of a coffee cup and a tropical drink, a brown paper grocery bag containing red peppers and other vegetables, a wood paneled backsplash, a stainless steel range hood, and various kitchen utensils, pots, and pans on the counter. In the foreground on a white table, there are croissants and toast on a plate, a small dish of butter and jam, a glass French press coffee pot, glasses of a dark red beverage, a gray coffee mug, and a silver, white laptop computer. The lighting is bright, soft, and neutral, consistent with even indoor kitchen lighting, evenly illuminating the man's face without harsh shadows. The color palette is warm and neutral, dominated by white, light blue, tan, wood brown, and gray tones, with red accents from the peppers and beverage. The composition is a medium close up, closeup, upper body framing, with the man positioned slightly off center in the frame, facing toward the laptop. The visual style is photographic, realistic, and resembles a lifestyle or family style stock video with a moderate depth of field, keeping the kitchen background recognizable but softly blurred.",
      "keyElements": [
        "refrigerator",
        "cabinet",
        "framed pictures",
        "grocery bag",
        "vegetables",
        "backsplash",
        "range hood",
        "utensils",
        "pots",
        "pans",
        "croissants",
        "toast",
        "butter",
        "jam",
        "coffee pot",
        "beverage glasses",
        "coffee mug",
        "laptop",
        "shirt pattern",
        "lighting"
      ],
      "attributes": [
        "warm",
        "friendly",
        "welcoming",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "moderate depth of field",
        "bright lighting",
        "natural light",
        "neutral tone",
        "warm tone",
        "family",
        "lifestyle",
        "man",
        "elderly",
        "senior",
        "gray hair",
        "white hair",
        "eyeglasses",
        "glasses",
        "goatee",
        "floral pattern",
        "shirt",
        "kitchen",
        "refrigerator",
        "grocery bag",
        "vegetables",
        "croissant",
        "toast",
        "coffee",
        "laptop",
        "video call"
      ]
    },
    {
      "fileName": "GENERIC-Family-04.mp4",
      "description": "The video shows two people, one woman and one man, relaxing together indoors on a sofa in the evening. The woman is an adult female with a fair skin tone and long, blonde hair styled in a high ponytail, leaning over the man's shoulder from behind, wearing a top, a beige, tan colored oversized cardigan or sweater, smiling broadly with her mouth open, giving a joyful, warm, affectionate visible expression. The man is an adult male with a fair skin tone, short reddish brown hair, and a full beard, wearing a jacket, a blue, light blue denim jacket, layered over a white t-shirt, along with olive green pants, holding a phone, a black smartphone, in one hand, smiling broadly with his mouth open, showing white teeth, giving a joyful, happy, relaxed visible expression. The setting is an indoor living room and kitchen environment, showing dark gray kitchen cabinets, a wood toned accent wall or pillar, a small potted plant, a warm glowing light bulb or lamp on a wooden side table, and a cream, off white colored sofa or couch with a soft blanket. The lighting is warm and dim, consistent with evening ambient lighting from a single glowing lamp, creating a cozy, intimate atmosphere with soft shadows. The color palette is warm and muted, dominated by tan, beige, denim blue, olive green, and dark gray tones, with a warm orange glow from the lamp. The composition is a medium close up, closeup, upper body framing, with both people positioned toward the center of the frame, angled toward the phone screen. The visual style is photographic, realistic, and resembles a lifestyle or couple style stock video with a shallow depth of field and warm, cozy ambient lighting.",
      "keyElements": [
        "kitchen cabinets",
        "accent wall",
        "potted plant",
        "lamp",
        "side table",
        "sofa",
        "blanket",
        "phone",
        "cardigan color",
        "jacket color",
        "lighting"
      ],
      "attributes": [
        "joyful",
        "warm",
        "affectionate",
        "happy",
        "relaxed",
        "candid",
        "portrait",
        "close up",
        "closeup",
        "medium close up",
        "shallow depth of field",
        "warm lighting",
        "dim lighting",
        "cozy",
        "intimate",
        "ambient light",
        "lifestyle",
        "couple",
        "woman",
        "man",
        "blonde hair",
        "ponytail",
        "cardigan",
        "beard",
        "denim jacket",
        "blue",
        "olive green",
        "tan",
        "beige",
        "phone",
        "smartphone",
        "sofa",
        "couch",
        "lamp",
        "plant"
      ]
    }
  ]
}
